import {
  goBack,
  useMfaCountryCodes,
  useScreen,
} from '@auth0/auth0-acul-react/mfa-country-codes';

interface PhonePrefix {
  country: string;
  country_code: string;
  phone_prefix: string;
}

export const useMfaCountryCodesManager = () => {
  const mfaCountryCodes = useMfaCountryCodes();
  const screen = useScreen();

  const { texts, data } = screen ?? {};

  // Get phone prefixes from screen data
  const phonePrefixes: PhonePrefix[] =
    (data?.phone_prefixes as unknown as PhonePrefix[]) ?? [];

  const handleSelectCountryCode = async (
    countryCode: string,
    phonePrefix: string,
  ): Promise<void> => {
    await mfaCountryCodes.selectCountryCode({
      country_code: countryCode,
      phone_prefix: phonePrefix,
    });
  };

  const handleBackAction = async (): Promise<void> => {
    await goBack({});
  };

  return {
    mfaCountryCodes,
    handleSelectCountryCode,
    handleBackAction,
    texts: texts ?? {},
    phonePrefixes,
  };
};
